/**
 * Blog navigation categories for Daily Sports Life /blog
 */

export const BLOG_CATEGORIES = [
  {
    id: 'all',
    label: 'All posts',
    shortLabel: 'All',
    description: 'Everything on the blog—wellness, events, and club updates.',
    path: '/blog',
  },
  {
    id: 'food-diet',
    label: 'Food & Diet',
    shortLabel: 'Food & Diet',
    description: 'Healthy meal plans for all visitors—global 7-day menus plus Ohio Indian plans by age and gender.',
    path: '/blog/category/food-diet',
  },
  {
    id: 'exercise',
    label: 'Exercise & Training',
    shortLabel: 'Exercise',
    description: 'Wellness plans, position drill guides (GK, defender, forward), and conditioning by age.',
    path: '/blog/category/exercise',
  },
  {
    id: 'sports-events',
    label: 'Sports Events',
    shortLabel: 'Events',
    description: 'Matchups, tournaments, and stories from the world game.',
    path: '/blog/category/sports-events',
  },
  {
    id: 'boat-races',
    label: 'Kerala Boat Races',
    shortLabel: 'Boat Races',
    description:
      'Nehru Trophy, vallamkali, and Kuttanad snake-boat racing — guides in English and Malayalam.',
    path: '/blog/category/boat-races',
  },
  {
    id: 'club-news',
    label: 'Club Stories',
    shortLabel: 'Clubs',
    description: 'Local field guides, family outdoor ideas, and community soccer resources.',
    path: '/blog/category/club-news',
  },
];

export function getCategoryById(categoryId) {
  if (!categoryId || categoryId === 'all') return BLOG_CATEGORIES[0];
  return BLOG_CATEGORIES.find((c) => c.id === categoryId) ?? null;
}

/** @param {object} post — list or detail post shape */
export function resolvePostBlogCategory(post) {
  if (post?.blogCategory) return post.blogCategory;
  const plan = post?.wellnessMeta?.planType;
  if (plan === 'hub' || plan === 'vegetarian-diet' || plan === 'nonveg-diet') {
    return 'food-diet';
  }
  if (plan === 'training') return 'exercise';
  if (post?.featured && post?.clubName === 'World Cup Desk') return 'sports-events';
  return 'club-news';
}

export function getCategoryLabel(categoryId) {
  const cat = categoryId === 'all' ? BLOG_CATEGORIES[0] : BLOG_CATEGORIES.find((c) => c.id === categoryId);
  return cat?.label ?? 'Blog';
}
